import React, { useEffect, useState } from "react";
import Loader from "../../components/loader";
import useFruitStore from "../../store/fruits";
import { useTranslation } from "react-i18next";
import ProductCard from "../../components/productCard";
import CustomButton from "../../components/customButton";
import { scrollToTop } from "../../lib/utils";

const ListProduitHome = () => {
  const { filteredFruits, loadingAllFruit, fetchAllFruit } = useFruitStore();
  const [filterProduct, setFilterproduct] = useState<any[]>([])

  const { t, i18n } = useTranslation(); // Translation hook

  const handleChange = (value: string) => {
    const label = value.toLocaleLowerCase()
    const search = [...filteredFruits].reverse().filter((item: any) => item.product_name.toLocaleLowerCase().includes(label) || item.sale_name.toLocaleLowerCase().includes(label) || item.variety.toLocaleLowerCase().includes(label))
    setFilterproduct(search)
  }


  useEffect(() => {
    scrollToTop()
  }, [])


  useEffect(() => {
    // Appelle l'API pour récupérer les fruits
    fetchAllFruit();
  }, [fetchAllFruit]);
  useEffect(() => {
    setFilterproduct([...filteredFruits].reverse())
    // eslint-disable-next-line
  }, [fetchAllFruit])
  // const products = [...filteredFruits].reverse()
  // console.log(products)

  return (
    <div className="h-full w-full flex  pt-5 pb-1 container mx-auto">
      <section className="bg-white w-full py-8" style={{ marginTop: "1%" }}>
        <div className="container w-full mx-auto">
          <div className=" flex flex-row justify-between w-full  text-left my-4">
            <h2 className="text-2xl font-bold">{t("home_new_products")}</h2>
            <div>
              <div className="flex gap-[0.8px]">
                <div
                  style={{ boxShadow: "0px 4px 4px 0px hsla(0, 0%, 0%, 0.25)" }}
                  className="min-w-[200px] sm:min-w-[357px] border-[2px] h-[37px] rounded-l-[29px] border-solid border-grey relative"
                >
                  <div className="absolute left-2 top-0 bottom-0 flex items-center">
                    <img src="/greySearch.svg" alt="" />
                  </div>
                  <input
                    onChange={(e) => handleChange(e.target.value)}
                    className="placeholder:text-grey rounded-l-[29px] pl-8 text-xs font-normal h-full w-full min-w-[90px]  border-none focus:outline-none focus:ring-0 focus:border-transparent"
                    placeholder="Rechercher un produit"
                  />
                </div>
                <CustomButton
                  startIcon="/search-icon.svg"
                  className=" h-[38px] bg-black rounded-r-[29px] max-w-[120px] px-3 py-2"
                >
                  <span className="text-xs font-normal text-white">Rechercher</span>
                </CustomButton>
              </div>
            </div>
          </div>

          <div className="">
            {loadingAllFruit ? (
              <Loader />
            ) : (
              <div className="flex flex-row justify-start flex-wrap gap-4 ">
                {filterProduct.map((fruit: any) => (
                  <ProductCard
                    key={fruit.product_id}
                    category_name={fruit.category_name}
                    uml={fruit.uml}
                    image={JSON.parse(fruit.images)[0]}
                    title={i18n.language === "fr" ? fruit.product_name : fruit.product_name_en}
                    sub_category_name={fruit.sub_category_name}
                    quality={fruit.minimum_quantity}
                    price={fruit.price}
                    stock={fruit.quantity}
                    quantity={fruit.quantity}
                    productId={fruit.product_id}
                  // seller={product.sale_name}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ListProduitHome;
